var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar-container"},[_c('div',{staticClass:"progress-bar",style:({'height': _vm.percentage * 100 + '%'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }